import { Component, ViewChild, Output, EventEmitter, OnInit, Input, AfterViewInit, HostListener } from '@angular/core';
import { ModalComponent } from '../../core/shared/modal/modal.component';
import { NgForm } from '@angular/forms';
import { DictionaryRest } from './dictionary.rest';
import { PermissionsService } from '../../core/services/permissions/permissions.service';
import { Permissions, HasPermissions } from '../../core/services/permissions/permissions.model';

@Component({
    selector: 'smp-dictionary',
    templateUrl: 'dictionary.component.html'
})
export class DictionaryComponent implements OnInit, HasPermissions {
    @ViewChild('dictionaryForm') dictionaryForm: NgForm;
    @ViewChild(ModalComponent) private modal: ModalComponent;
    @Output() onSuccess = new EventEmitter();

    @Input() title: string;
    @Input() dictionaryType: number;

    @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (this.modal.modalRoot.isShown === true && this.dictionaryForm.valid) {
            this.saveDictionary();
            event.preventDefault();
        }
    }

    public dictionary: any = { 'value': '' };
    private editMode: boolean;
    private isSaving = false;

    constructor(
        private rest: DictionaryRest,
        private permissionService: PermissionsService
    ) {
    }

    public ngOnInit() {
        this.setPermissions('UniversalDictionary');

        this.modal.title = this.title;
    }

    permissions: Permissions;
    private canBeEdited: boolean;

    setPermissions(claimType: string): void {
        this.permissions = this.permissionService.getUserPermissions(claimType);
        this.canBeEdited = this.permissions.canEdit;
    }

    public openForAdding() {
        this.editMode = false;
        this.dictionary = { 'dictionaryType': this.dictionaryType };
        this.modal.open();
    }

    public openForEdit(id: any) {
        this.editMode = true;
        this.rest.getDictionary(id).subscribe(dictionary => {
            this.dictionary = dictionary;
            this.modal.open();
        });
    }

    public deleteDictionary(id: any) {
        this.rest.deleteDictionary(id).subscribe(() => {
            this.rest.deleteDictionary(id);
            this.onSuccess.emit({});
        });
    }

    public setError(controlName: string) {
        const control = this.dictionaryForm.controls[controlName];
        return { 'has-error': control.dirty && !control.valid };
    }

    public getDisabledStatus() {
        if (this.editMode) {
            return !this.dictionaryForm.valid;
        } else {
            return !this.dictionaryForm.valid || !this.dictionaryForm.dirty;
        }
    }

    public closeModal() {
        this.modal.close();
    }

    public saveDictionary() {
        if (this.isSaving) {
            return;
        }
        this.isSaving = true;
        const action = this.editMode ? this.rest.saveDictionary : this.rest.addDictionary;
        action.call(this.rest, this.dictionary).subscribe(() => {
            this.modal.close();
            this.onSuccess.emit({});
            this.isSaving = false;
        });
    }
}
